import { gatewayApiClient } from '../../_shared/api/gatewayApiClient';
import type { PageResponse } from '../../_shared/types/shared';
import type { RouteRow, RouteFormValues, RouteFilters, ServiceOption } from '../types/route';

export const routesApi = {
  list: async (params: RouteFilters & { page: number; size: number; sort?: string }) => {
    const response = await gatewayApiClient.get<PageResponse<RouteRow>>('/routes', { params });
    return response.data;
  },

  get: async (id: string) => {
    const response = await gatewayApiClient.get<RouteRow>(`/routes/${id}`);
    return response.data;
  },

  create: async (body: RouteFormValues) => {
    const response = await gatewayApiClient.post<RouteRow>('/routes', body);
    return response.data;
  },

  replace: async (id: string, body: RouteFormValues) => {
    const response = await gatewayApiClient.put<RouteRow>(`/routes/${id}`, body);
    return response.data;
  },

  patch: async (id: string, body: Partial<RouteFormValues>) => {
    const response = await gatewayApiClient.patch<RouteRow>(`/routes/${id}`, body);
    return response.data;
  },

  delete: async (id: string) => {
    await gatewayApiClient.delete(`/routes/${id}`);
  },

  listServices: async (): Promise<ServiceOption[]> => {
    // #414: BE returns plain list (List<GatewayServiceResponse>) — serviceKey maps to id
    const response = await gatewayApiClient.get<ServiceOption[] | { content: ServiceOption[] }>('/services', {
      params: { size: 200 },
    });
    // Handle both plain list and PageResponse shapes
    const data = response.data;
    if (Array.isArray(data)) {
      // Map GatewayServiceResponse { id, serviceKey, name } → ServiceOption { id, name }
      return (data as Array<{ id: string; serviceKey: string; name: string }>).map((s) => ({
        id: s.serviceKey ?? s.id,
        name: s.name,
      }));
    }
    // Fallback for PageResponse shape
    return (data as { content: ServiceOption[] }).content ?? [];
  },
};
